class SubscribeBlock {
  constructor(element) {
    this.root = element;
    this.form = this.root.querySelector('.subscribe__form');
    this.input = this.root.querySelector('.subscribe__input');
    this.status = this.root.querySelector('.subscribe__status');
    this.isSubmitting = false;

    if (!this.form || !this.input) {
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  setStatus(message, type = 'info') {
    if (!this.status) return;

    this.status.textContent = message;
    this.status.classList.remove('subscribe__status--error', 'subscribe__status--success');

    if (type === 'error') {
      this.status.classList.add('subscribe__status--error');
    } else if (type === 'success') {
      this.status.classList.add('subscribe__status--success');
    }
  }

  validate() {
    const value = this.input.value.trim();
    if (!value) {
      this.setStatus('Email is required', 'error');
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      this.setStatus('Invalid email format', 'error');
      return false;
    }

    this.setStatus('');
    return true;
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (this.isSubmitting) {
      return;
    }

    if (!this.validate()) {
      return;
    }

    if (typeof backendData === 'undefined' || !backendData.ajaxUrl) {
      this.setStatus('Configuration error', 'error');
      return;
    }

    this.isSubmitting = true;
    this.form.classList.add('subscribe__form--loading');
    this.setStatus('Subscribing...');

    const formData = new FormData();
    formData.append('action', 'subscribe_newsletter');
    formData.append('email', this.input.value.trim());
    formData.append('nonce', backendData.nonce || '');

    try {
      const response = await fetch(backendData.ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        this.setStatus(data.data?.message || 'Thank you for subscribing!', 'success');
        this.form.reset();
      } else {
        this.setStatus(data.data?.message || 'Subscription failed. Please try again.', 'error');
      }
    } catch (error) {
      this.setStatus('Network error. Please try again.', 'error');
    } finally {
      this.isSubmitting = false;
      this.form.classList.remove('subscribe__form--loading');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.subscribe').forEach((block) => {
    new SubscribeBlock(block);
  });
});
